module.exports = __webpack_public_path__ + "static/media/1207838.c07d8794.svg";